import { combineReducers } from 'redux';

import {
  SHOW_CONFIRM,
  CANCEL_CONFIRM,
  CLOSE_CONFIRM,
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  CLEAR_NOTIFICATIONS
} from './Dialogs.actions';
import { isErrorNotification, notificationStyle } from '../../../../admin/components/common/Dialogs/Notification/Notification.utils';

const confirm = (state = false, action) => {
  switch (action.type) {
    case SHOW_CONFIRM:
      return action.payload;
    case CLOSE_CONFIRM:
    case CANCEL_CONFIRM:
      return false;
    default:
      return state;
  }
};

const notifications = (state = [], action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION: {
      const { payload } = action;
      const id = `${Math.random().toString(36).substr(2, 12)}_${Date.now()}}`;
      const newNotification = isErrorNotification(payload)
        ? { id, data: payload, style: notificationStyle.error }
        : { 
            id,
            data: payload.text,
            style: payload.style || notificationStyle.gray,
            closeDelay: payload.closeDelay
          };
      
      return [...state, newNotification];
    }
    case HIDE_NOTIFICATION:
      if (action.payload) {
        return state.filter((n) => n.id !== action.payload);
      }
      return state.slice(0, -1);
    case CLEAR_NOTIFICATIONS:
      return [];
    default:
      return state;
  }
};

// MAIN
const reducer = combineReducers({
  confirm,
  notifications
});

reducer.reducer = 'dialogs';

export default reducer;
